import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import analyticsUtils from 'app/client/utils/analyticsUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

import './style.scss';

const propTypes = {
    details: PropTypes.object.isRequired,
    // dispatch is only requried if you want to trigger GA events
    dispatch: PropTypes.func,
};

const defaultProps = {
    dispatch: null,
};

class BannerMaintenance extends React.PureComponent {
    constructor(props) {
        super(props);

        // bind methods
        this.handleCTAClick = this.handleCTAClick.bind(this);
    }

    componentDidMount() {
        const { dispatch, details } = this.props;
        const { id } = details;

        // from api- keepe - id =1 homee- id=2
        const GAEvent = id === '1' ? AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_DISPLAYED_KEEPE :
            AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_DISPLAYED_HOMEE;

        if (dispatch) {
            dispatch(analyticsUtils.track.GAEventV2(GAEvent));
        }
    }

    handleCTAClick() {
        const { details, dispatch } = this.props;
        const { referralUrl: btnUrl, id } = details;

        // from api- keepe - id =1 homee- id=2
        const GAEvent = id === '1' ? AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_CLICK_KEEPE :
            AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_CLICK_HOMEE;

        if (dispatch) {
            dispatch(analyticsUtils.track.GAEventV2(GAEvent));
        }

        window.open(btnUrl, 'newTab');
    }

    render() {
        const { details } = this.props;
        const {
            description,
            displayName,
            title,
            id = '1',
        } = details;
        const btnTitle = `Try ${displayName}`;

        return (
            <div className="BannerMaintenance">
                <div className="BannerSection--Top">
                    <div className="BannerIconContainer">
                        <div
                            className={cx('BuilderIcon', {
                                'BuilderIcon-homee': id === '2',
                                'BuilderIcon-keepe': id === '1',
                            })}
                        />
                    </div>

                    <div className="BannerContentContainer">
                        <Text
                            className="BannerTitle"
                            type="body"
                        >
                            {title}
                        </Text>

                        <Text
                            className="BannerBody"
                            type="body-small"
                        >
                            {description}
                        </Text>
                    </div>
                </div>

                <div className="BannerButtonContainer">
                    <Button
                        className="Button-TryKeepe"
                        type="tertiary"
                        size="md"
                        // handlers
                        onClick={this.handleCTAClick}
                    >
                        {btnTitle}
                    </Button>
                </div>
            </div>
        );
    }
}

BannerMaintenance.defaultProps = defaultProps;
BannerMaintenance.propTypes = propTypes;

export default BannerMaintenance;
